/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Mantine
import {
	Input,
	InputProps as NativeInputProps,
} from '@mantine/core';

// Styles
import classes from './Searchbar.module.css';

// Icons
import { IconSearch } from '@tabler/icons-react';

interface InputProps extends NativeInputProps {
	onChange?: (
		event: React.ChangeEvent<HTMLInputElement>
	) => void;
	placeholder?: string | undefined;
}

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Searchbar = (props: InputProps) => {
	return (
		<Input
			leftSection={
				<IconSearch
					color="var(--mantine-color-grey)"
					size={'18px'}
				/>
			}
			classNames={classes}
			{...props}
		/>
	);
};
